export const applicationDetailAction= (data) => { 
    return {
       type: data.type,
       data: data.data
    }
 }